/**
 * @file 路由配置
 */


const account = {
    path: 'account',
    name: 'account',
    meta: {
        requiresAuth: true,
        label: '账户管理'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/system/account')));
    }
};
const auth = {
    path: 'auth',
    name: 'auth',
    meta: {
        requiresAuth: true,
        label: '角色权限'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/system/auth')));
    }
};

const carousel = {
    path: 'carousel',
    name: 'carousel',
    meta: {
        requiresAuth: true,
        label: '轮播图管理'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/system/carousel')));
    }
};
const user = {
    path: 'user',
    name: 'user',
    meta: {
        requiresAuth: true,
        label: '用户信息'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/system/user')));
    }
};

const customer = {
    path: 'customer',
    name: 'customer',
    meta: {
        requiresAuth: true,
        label: '客户管理'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/system/customer')));
    }
};

export default {
    path: '/system',
    name: 'system',
    redirect: '/system/carousel',
    icon: 'el-icon-s-tools',
    meta: {
        requiresAuth: true,
        label: '系统管理'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/system')));
    },
    children: [user, carousel, customer]
};
